import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    operations: [],
};

// Getters
const getters = {
    operations: state => {
        return state.operations;
    },
};

// Actions
const actions = {
    getOperations(context, payload) {
        function successCallback(response) {
            context.commit('getOperationsHandler', { operations: response.data.lastOperations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Auteur.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getOperationsHandler(state, { operations }) {
        // Update antecedents state
        state.operations = operations;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}